export const Title = ({ children }: { children: React.ReactNode }) => {
  return (
    <header style={{ fontSize: '20px', fontWeight: '500', textTransform: 'capitalize' }}>
      {children}
    </header>
  );
}